import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function BlockedRoadIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 54 54"
  }, props), /*#__PURE__*/React.createElement("rect", {
    fill: "#666A6F",
    height: "21.7878",
    rx: "2.84189",
    width: "5.68378",
    x: "37.1975",
    y: "23.2095"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#666A6F",
    height: "21.7878",
    rx: "2.84189",
    width: "5.68378",
    x: "10.6729",
    y: "23.2095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99976 11.2228V26.4944C1.99976 27.7236 2.89655 28.7201 4.00275 28.7201H49.5518C50.658 28.7201 51.5548 27.7236 51.5548 26.4944V11.2228C51.5548 9.99357 50.658 8.99707 49.5518 8.99707H4.00275C2.89655 8.99707 1.99976 9.99357 1.99976 11.2228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8309 9L25.0218 28.7212H9.78711L28.5962 9H43.8309Z",
    fill: "#F36565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4067 12.1582V23.7613C51.4067 26.0742 49.7102 27.9474 47.6155 27.9474H36.25L51.4067 12.1582Z",
    fill: "#F36565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2512 9.00049L3.09448 24.7897V13.2421C3.09448 10.8985 4.81316 9.00049 6.94368 9.00049H18.2512Z",
    fill: "#F36565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99976 15.5185C1.99976 11.9184 4.9182 9 8.51827 9H26.9998V29H8.51827C4.9182 29 1.99976 26.0816 1.99976 22.4815V15.5185Z",
    fill: "#2C2E30",
    opacity: "0.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3547 27.0005V29.0005H6.14771V27.0005H48.3547ZM50.3547 25.0005V13.0005C50.3547 11.896 49.4592 11.0007 48.3547 11.0005H6.14771C5.04313 11.0005 4.14771 11.8959 4.14771 13.0005V25.0005C4.14788 26.1049 5.04324 27.0005 6.14771 27.0005V29.0005L5.94165 28.9946C3.89631 28.8908 2.25604 27.251 2.15259 25.2056L2.14771 25.0005V13.0005C2.14771 10.8605 3.82826 9.1126 5.94165 9.00537L6.14771 9.00049H48.3547L48.5598 9.00537C50.6735 9.11228 52.3547 10.8602 52.3547 13.0005V25.0005L52.3489 25.2056C52.2454 27.2512 50.6055 28.8911 48.5598 28.9946L48.3547 29.0005V27.0005C49.4591 27.0003 50.3546 26.1048 50.3547 25.0005Z",
    fill: "#DDE0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99976 25.0001V13C1.99983 10.791 3.79074 9.00007 5.99978 9H27V11.0003H5.99978C4.89532 11.0004 4.00014 11.8956 4.00007 13V25.0001C4.00007 26.1046 4.89527 27.0003 5.99978 27.0004H27V29.0001H5.99978C3.7907 29 1.99976 27.2092 1.99976 25.0001Z",
    fill: "#B9BDC3"
  }));
}